import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-btn-primary-white',
  templateUrl: './btn-primary-white.component.html',
  styleUrls: ['./btn-primary-white.component.css']
})
export class BtnPrimaryWhiteComponent implements OnInit {

  @Output() callOnClick: EventEmitter<string> = new EventEmitter();
  @Input() btnLabel: string;
  @Input() isDisabled: string;
  @Input() routeTo: string;

  constructor() { }

  ngOnInit() {
  }

  onBtnClick(): boolean {
    if (this.isDisabled === 'true') {
      return false;
    }
    this.callOnClick.emit();
    return true;
  }

}
